import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cn } from '@/utils/cn';
import type { AvatarProps } from './Avatar.types';
import styles from './Avatar.module.scss';

export function Avatar({
  src,
  alt,
  fallback,
  size = 'md',
  isLoading = false,
  className,
  ...props
}: AvatarProps) {
  const avatarClasses = cn(
    styles.avatar,
    styles[`avatar--${size}`],
    isLoading && styles['avatar--loading'],
    className
  );

  return (
    <AvatarPrimitive.Root className={avatarClasses} {...props}>
      {!isLoading && src && (
        <AvatarPrimitive.Image className={styles.avatar__image} src={src} alt={alt || fallback} />
      )}

      <AvatarPrimitive.Fallback className={styles.avatar__fallback} delayMs={600}>
        {isLoading ? (
          <span className={styles.avatar__spinner} aria-label="Loading" />
        ) : (
          <span className={styles.avatar__fallback__text}>{fallback}</span>
        )}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}

export default Avatar;
